import { Chip, Stack } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { CustomTypesChannelFilter } from "../channel";

interface ChatChannelTypeFilterProps {
  customTypesFilter: CustomTypesChannelFilter;
  onFilterChange: (filterValue: CustomTypesChannelFilter) => void;
  isStarredProfessionalEnabled: boolean;
  isPlacementsEnabled: boolean;
}

interface ChatFilterChipProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
}

export function ChatFilterChip({ label, isSelected, onClick }: ChatFilterChipProps) {
  return (
    <Chip
      label={label}
      variant="outlined"
      color={isSelected ? "primary" : "default"}
      clickable
      onClick={onClick}
      sx={(theme) => ({
        ...(isSelected && {
          color: theme.palette.primary.main,
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
        }),
      })}
    />
  );
}

export function ChatChannelTypeFilter({
  customTypesFilter,
  onFilterChange,
  isStarredProfessionalEnabled,
  isPlacementsEnabled,
}: ChatChannelTypeFilterProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        padding: 1,
        overflowX: "auto",
        flexWrap: "nowrap",
      }}
    >
      <ChatFilterChip
        label="All"
        isSelected={customTypesFilter === "all"}
        onClick={() => {
          onFilterChange("all");
        }}
      />
      {isPlacementsEnabled && (
        <>
          <ChatFilterChip
            label="Flex"
            isSelected={customTypesFilter === "flex"}
            onClick={() => {
              onFilterChange("flex");
            }}
          />
          <ChatFilterChip
            label="Hiring"
            isSelected={customTypesFilter === "placements"}
            onClick={() => {
              onFilterChange("placements");
            }}
          />
        </>
      )}
      {isStarredProfessionalEnabled && (
        <ChatFilterChip
          label="Starred"
          isSelected={customTypesFilter === "starred"}
          onClick={() => {
            onFilterChange("starred");
          }}
        />
      )}
    </Stack>
  );
}
